import { render, staticRenderFns } from "./SSelect2.vue?vue&type=template&id=55405e0c"
import script from "./SSelect2.vue?vue&type=script&lang=js"
export * from "./SSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports